import * as React from 'react'
import { useVehicleForm } from '../../context/VehicleFormContext'
import { TextField } from '@/ui/form/controls/TextField'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { Switch } from '@/ui/form/primitives/Switch'
import { TripVehicleType } from '@/app/constants/delegation/tripVehicleType'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const BasicDataStage = () => {
  const { isActive, setIsActive, data, setData, countriesOptions, countries } =
    useVehicleForm()
  const { t } = useLocalize()

  const vehicleTypeOptions = [
    { label: t('vehicleModule.vehicle-type-not-set'), value: '-1' },
    { label: t('vehicleModule.vehicle-type-above-3-5'), value: '0' },
    { label: t('vehicleModule.vehicle-type-below-3-5'), value: '1' },
    { label: t('vehicleModule.vehicle-type-bus'), value: '2' },
    { label: t('vehicleModule.vehicle-type-minibus'), value: '6' },
  ]

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex-1">
        <p className="tw-m-0 tw-text-lg tw-font-semibold tw-text-content-base">
          {t('vehicleBasics.data')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('vehicleBasics.registration-number')}
          required
          placeholder={t('vehicleModule.placeholder-type')}
          name="registrationNumber"
          value={data?.registrationNumber || ''}
          onChange={(e) =>
            setData({ ...data, registrationNumber: e.target.value })
          }
        />
        <TextField
          label={t('vehicleBasics.registration-number-from-tachograph')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.registrationNumberFromTachograph || ''}
          onChange={(e) =>
            setData({
              ...data,
              registrationNumberFromTachograph: e.target.value,
            })
          }
        />
        <TextField
          label={t('vehicleBasics.vin-number')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.vinNumber || ''}
          onChange={(e) => setData({ ...data, vinNumber: e.target.value })}
        />
        <TextField
          label={t('vehicleBasics.make')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.make || ''}
          onChange={(e) => setData({ ...data, make: e.target.value })}
        />
        <TextField
          label={t('vehicleBasics.model')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.model || ''}
          onChange={(e) => setData({ ...data, model: e.target.value })}
        />
        <TextField
          label={t('vehicleBasics.company')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.company || ''}
          onChange={(e) => setData({ ...data, company: e.target.value })}
        />
        <TextField
          label={t('vehicleBasics.phone-number')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.phoneNumber || ''}
          onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
        />
        <FieldsetSelect
          label={t('vehicleBasics.registration-country')}
          placeholder={t('vehicleModule.placeholder-select-country')}
          options={countriesOptions}
          value={data?.registrationCountry?.id?.toString() || ''}
          onChange={(e) => {
            const selectedCountry = countries?.find(
              (c) => c.id.toString() === e.target.value,
            )
            setData({ ...data, registrationCountry: selectedCountry })
          }}
        />
        <TextField
          label={t('vehicleBasics.registry-number')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.registryNumber || ''}
          onChange={(e) => setData({ ...data, registryNumber: e.target.value })}
        />
        <FieldsetSelect
          label={t('vehicleBasics.vehicle-type')}
          placeholder={t('vehicleModule.placeholder-select-type')}
          options={vehicleTypeOptions}
          value={data?.vehicleType?.toString() || '-1'}
          onChange={(e) => {
            const vehicleType = parseInt(e.target.value) as TripVehicleType
            setData({ ...data, vehicleType })
          }}
        />
        <div className="tw-h-[1px] tw-w-full tw-bg-base-300"></div>
        <div className="tw-flex tw-items-center tw-justify-between">
          <p className="tw-text-sm tw-font-medium tw-text-content-base">
            {t('vehicleBasics.active')}
          </p>
          <Switch
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
        </div>
      </div>
    </div>
  )
}

export default BasicDataStage
